module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_2048.e70ca097.webp";